export default __webpack_public_path__ + "static/media/9f49a1572418526007765d5ca4b4b0cd1600253941305.1fbefda2.webp";